import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import { motion } from "framer-motion";

import {
    Code as CodeIcon,
    Storage as StorageIcon,
    Build as BuildIcon,
    Architecture as ArchitectureIcon,
    Psychology as PsychologyIcon,
    Cloud as CloudIcon,
} from "@mui/icons-material";

const Skills = () => {
    const skillCategories = [
        {
            title: "Languages",
            icon: <CodeIcon />,
            skills: [
                "Java",
                "JavaScript",
                "Python",
                "SQL",
                "HTML",
                "CSS",
            ],
        },

        {
            title: "Backend",
            icon: <ArchitectureIcon />,
            skills: [
                "Spring Boot",
                "Spring Security",
                "Spring MVC",
                "Node.js",
                "REST APIs",
                "JWT",
                "Hibernate/JPA",
            ],
        },

        {
            title: "Frontend",
            icon: <CodeIcon />,
            skills: [
                "React.js",
                "Material UI",
                "Responsive Design",
            ],
        },


        {
            title: "Databases & Storage",
            icon: <StorageIcon />,
            skills: [
                "PostgreSQL",
                "MySQL",
                "MongoDB",
                "Redis",
                "Firebase Firestore",
            ],
        },


        {
            title: "Tools & Platforms",
            icon: <BuildIcon />,
            skills: [
                "Git",
                "GitHub",
                "Docker",
                "Postman",
                "Maven",
                "Firebase",
                "Vercel",
            ],
        },


        {
            title: "Concepts",
            icon: <CloudIcon />,
            skills: [
                "OOP",
                "Design Patterns",
                "Distributed Systems",
                "Concurrency",
                "Multithreading",
                "Transactions",
                "Authentication",
                "Authorization",
            ],
        },


        {
            title: "Currently Exploring",
            icon: <PsychologyIcon />,
            skills: [
                "LangChain",
                "Vector Databases",
                "RAG Optimization",
                "Prompt Engineering",
                "Kubernetes",
                "AWS",
                "CI/CD",
                "Hybrid Search",
                "Agentic AI",
                "MCP",
                "Redis Streams",
                "RabbitMQ",
            ],
        },
    ];



    const containerVariants = {
        hidden:{
            opacity:0
        },

        visible:{
            opacity:1,
            transition:{
                staggerChildren:0.1
            }
        }
    };


    const itemVariants = {

        hidden:{
            y:20,
            opacity:0
        },

        visible:{
            y:0,
            opacity:1,
            transition: { duration: 0.3 }
        }

    };



    const getCategoryColor = () => {
        return 'var(--primary)';
    };

    return (

        <Box
            component="section"
            sx={{
                py:{ xs: 6, md: 12 },
                minHeight:{ xs: "auto", md: "100vh" },
                background:"transparent"
            }}
        >


            <Container>


                <Typography
                    variant="h3"
                    align="center"
                    sx={{
                        mb:6,
                        fontFamily:"'Chivo Mono', monospace",
                        fontWeight:700,
                        fontSize:{
                            xs:"2rem",
                            md:"3.5rem"
                        },
                        background: 'linear-gradient(135deg, #ffffff, rgba(255, 255, 255, 0.7))',
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.1))',
                        opacity: 1
                    }}
                >

                    Skills & Technologies

                </Typography>




                <motion.div

                    variants={containerVariants}

                    initial="hidden"

                    whileInView="visible"

                    viewport={{
                        once:true
                    }}

                >


                    <Box

                        sx={{

                            display:"grid",

                            gridTemplateColumns:{

                                xs:"1fr",

                                md:"repeat(2,1fr)"

                            },


                            gap:3,

                            alignItems:"start"

                        }}

                    >



                        {
                            skillCategories.map((skillCategory, categoryIndex)=>(


                                <Box

                                    key={categoryIndex}

                                    sx={{

                                        gridColumn:

                                            skillCategory.title==="Currently Exploring"

                                                ?

                                                "1 / -1"

                                                :

                                                "auto"

                                    }}

                                >


                                    <motion.div

                                        variants={itemVariants}

                                    >


                                        <Paper
                                            className="glass-card"
                                            sx={{
                                                p:{xs:2, sm:3, md:4},
                                                minHeight:170,
                                                display:"flex",
                                                flexDirection:"column",
                                                justifyContent:"space-between",
                                                bgcolor: "transparent",
                                                border: "none",
                                                boxShadow: "none",
                                                "&:hover":{
                                                    transform:"none",
                                                    boxShadow:"none",
                                                    borderColor: getCategoryColor()
                                                }
                                            }}
                                        >



                                            <Box

                                                sx={{

                                                    textAlign:"center",

                                                    mb:3

                                                }}

                                            >



                                                <Box
                                                    sx={{
                                                        color: '#ffffff',
                                                        "& svg":{
                                                            fontSize:38
                                                        }
                                                    }}
                                                >
                                                    <motion.div
                                                        animate={{
                                                            rotateY: [0, 360],
                                                        }}
                                                        transition={{
                                                            duration: 4,
                                                            repeat: Infinity,
                                                            ease: "linear",
                                                            delay: categoryIndex * 0.5
                                                        }}
                                                    >
                                                        {skillCategory.icon}
                                                    </motion.div>
                                                </Box>



                                                <Typography

                                                    sx={{

                                                        mt:2,

                                                        fontWeight:700,

                                                        fontSize:"1.3rem",

                                                        color:"#ffffff"

                                                    }}

                                                >

                                                    {skillCategory.title}

                                                </Typography>


                                            </Box>





                                            <Box

                                                sx={{

                                                    display:"flex",

                                                    flexWrap:"wrap",

                                                    justifyContent:"center",

                                                    gap:1

                                                }}

                                            >



                                                {

                                                    skillCategory.skills.map((skillName, skillIndex)=>(


                                                        <motion.div
                                                            key={skillName}
                                                            variants={{
                                                                hidden: { opacity: 0, scale: 0.8 },
                                                                visible: { opacity: 1, scale: 1 }
                                                            }}
                                                            transition={{ delay: skillIndex * 0.03 }}
                                                        >
                                                            <Box

                                                                sx={{

                                                                    px:1.8,

                                                                    py:.8,


                                                                    borderRadius:1,


                                                                    fontSize:"0.95rem",


                                                                    color: '#ffffff',



                                                                    backgroundColor: 'rgba(255, 255, 255, 0.05)',



                                                                    border:"1px solid",


                                                                    borderColor: 'rgba(255, 255, 255, 0.1)',



                                                                    transition:".2s",



                                                                    "&:hover":{

                                                                        transform:"scale(1.1) translateY(-2px)",
                                                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                                                        boxShadow: '0 4px 10px rgba(255, 255, 255, 0.1)'

                                                                    }

                                                                }}

                                                            >

                                                                {skillName}

                                                            </Box>
                                                        </motion.div>


                                                    ))

                                                }



                                            </Box>



                                        </Paper>


                                    </motion.div>


                                </Box>


                            ))
                        }



                    </Box>



                </motion.div>



            </Container>


        </Box>

    );

};


export default Skills;